<!-- <div class="container">
    <ul class="list-book">
        <li *ngFor="let item of listBook" class="book-item" [routerLink]="['/quiz', item.code]">
            <img class="imgFace" [src]="item.url"/>
            <div>
                <span class="label-item">{{item.label}}</span>
                <span>{{item.desc}}</span>
            </div>
        </li>
    </ul>
</div> -->

<main role="main" class="container">
  <div class="d-flex align-items-center p-3 my-3 text-white-50 bg-purple rounded shadow-sm" style="background-color: #6f42c1;">
    <img class="mr-3" src="/assets/img/logo-blue.png" alt="" width="48" height="48">
    <div class="lh-100">
      <h6 class="mb-0 text-white lh-100">Quiz</h6>
      <small>{{listBook.length}} chủ đề</small>
    </div>
  </div>

  <div class="my-3 p-0 bg-white rounded shadow-sm">
    <h6 class="border-bottom border-gray pb-2 mb-0">Recent updates</h6>
	
    <div class="bl-quiz-item media text-muted p-3" *ngFor="let item of listBook" [routerLink]="['/quiz', item.code]" style="cursor: pointer;">
      <!-- <svg class="bd-placeholder-img mr-2 rounded" width="32" height="32" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder: 32x32" preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title><rect width="100%" height="100%" fill="#007bff"/><text x="50%" y="50%" fill="#007bff" dy=".3em">32x32</text></svg> -->
	  <img class="bd-placeholder-img mr-2 rounded" [src]="item.url" style="height: 56px;"/>
      <p class="media-body pb-3 mb-0 small lh-125 border-bottom border-gray">
        <strong class="d-block text-gray-dark">{{item.label}}</strong>
        {{item.desc}}
      </p>
    </div>
	
    <small class="d-block text-right mt-3">
      <a href="#">Tất cả</a>
    </small>
  </div>
<!-- 
  <div class="my-3 p-3 bg-white rounded shadow-sm">
    <h6 class="border-bottom border-gray pb-2 mb-0">Kết quả</h6>
	
	<div class="media text-muted pt-3">
	  <svg class="bd-placeholder-img mr-2 rounded" width="32" height="32" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder: 32x32" preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title><rect width="100%" height="100%" fill="#007bff"/><text x="50%" y="50%" fill="#007bff" dy=".3em">32x32</text></svg>
	
	  <div class="media-body pb-3 mb-0 small lh-125 border-bottom border-gray">
	    <div class="d-flex justify-content-between align-items-center w-100">
	      <strong class="text-gray-dark">Bài 1: abc</strong>
	      <a href="#">Làm bài</a>
	    </div>
	    <span class="d-block">19/20 - 01/06/2022</span>
	  </div>
	</div>
    <div class="media text-muted pt-3">
      <svg class="bd-placeholder-img mr-2 rounded" width="32" height="32" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder: 32x32" preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title><rect width="100%" height="100%" fill="#007bff"/><text x="50%" y="50%" fill="#007bff" dy=".3em">32x32</text></svg>

      <div class="media-body pb-3 mb-0 small lh-125 border-bottom border-gray">
        <div class="d-flex justify-content-between align-items-center w-100">
          <strong class="text-gray-dark">Bài 1: abc</strong>
          <a href="#">Làm bài</a>
        </div>
        <span class="d-block">19/20 - 01/06/2022</span>
      </div>
    </div>
	
	<small class="d-block text-right mt-3">
      <a href="#">Tất cả</a>
    </small>
  </div> -->
</main>